import { api, getTenantSlug } from './api';

export interface PortalBranding {
  logoUrl: string | null;
  faviconUrl: string | null;
  primaryColor: string;
  secondaryColor: string;
  companyName: string | null;
  tenantName: string;
}

const DEFAULT_BRANDING: PortalBranding = {
  logoUrl: null,
  faviconUrl: null,
  primaryColor: '#3B82F6',
  secondaryColor: '#1E40AF',
  companyName: null,
  tenantName: 'Musteri Portali',
};

export const brandingService = {
  getBranding: async (): Promise<PortalBranding> => {
    try {
      const tenantSlug = getTenantSlug();
      const response = await api.get<PortalBranding>(`/branding/portal/${tenantSlug}`);
      return response.data;
    } catch {
      return DEFAULT_BRANDING;
    }
  },

  getImageUrl: (url: string | null | undefined): string | null => {
    if (!url) return null;
    // If it's a relative URL, prepend the API base URL
    if (url.startsWith('/')) {
      const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:5001';
      return `${baseUrl}${url}`;
    }
    return url;
  },
};
